export default __webpack_public_path__ + "static/media/18.f1c9904b.png";